import React, { Component } from 'react'
import Client from '../Client'
import BlackLoading from '../images/black-loader.gif';
import {Carousel} from 'react-bootstrap';

class LocallyGrownFlashImages extends Component {
  constructor(props) {
    super(props)
    this.state = {
         locallygrownflashimgpage:[]
    }
}

componentDidMount(){
    Client.getEntries({
        'content_type': 'locallygrownFlashImages'

    }).then((entries)=>{
        this.setState({locallygrownflashimgpage: entries.items})
    });
}


render() {
  return (
    <>
        {this.state.locallygrownflashimgpage.length === 0 ?
              <div align="center"><img src={BlackLoading} alt="Loading..." /></div> :
        <Carousel fade={false}>
          
          {this.state.locallygrownflashimgpage.map((item, index) => {
            return(
            <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              src={item.fields.locallygrownFlashImagesImg.fields.file.url}
              alt="sam bridge locally grown slide"
            />
            <Carousel.Caption>
                <span className="slidefont">{item.fields.locallygrownFlashImagesTitle}</span>
            </Carousel.Caption>
            </Carousel.Item>
                  )
                  })}
        </Carousel>
        }

    </>
    )
  }
}

export default LocallyGrownFlashImages;


